import React, {Component} from 'react';
import ReviewLooxStar from './LooxStar';
import './Loox.css';

class Loox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  };

  render() {
    //test 4
    let rating = this.props.dataRating;
    let stars = [];
    for(let i=0;i<5;i++){
      let star_value = rating-i;
      if( star_value>1 ) star_value = 1;
      else if( star_value<0 ) star_value = 0;
      else star_value = Math.round(star_value*100)/100;
      stars.push(star_value);
    }
    let rating_title = rating+" rating ("+this.props.dataReviews+" votes)";

    return (
      <div className="review_loox_container">
        <span className="review_loox" title={rating_title}>
          {stars.length>0 && stars.map((data, i) => 
            <ReviewLooxStar 
                key = {"review_star_"+i}
                data = {data}
                title={"test1"}
            />
          )}
        </span>

        {(() => {
          if ((this.props.dataReviews??null)!==null) {
            return (
              <span className="review_loox_reviews ml-1 mr-2">({this.props.dataReviews})</span>
            )
          }
        })()}
      </div>
    )
  };
}

export default Loox;